import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Privacy Policy - Informativa sulla Privacy"
        description="Informativa sulla privacy di Mangimi Rubini. Scopri come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali secondo il GDPR."
        canonical="/privacy-policy"
      />
      <Navbar />

      <div className="pt-24 pb-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link to="/" className="inline-block mb-6">
            <Button variant="outline">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Torna alla Home
            </Button>
          </Link>

          <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>

          <div className="bg-white rounded-lg shadow-sm p-8 space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-4">1. Titolare del Trattamento</h2>
              <p className="text-gray-700 leading-relaxed">
                Il Titolare del trattamento dei dati personali è:<br />
                <strong>Mangimi Rubini</strong><br />
                Viale Umbria 21, 06063 Magione (PG)<br />
                Email: mangimirubini@gmail.com<br />
                Telefono: +39 346 625 7639
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">2. Tipologie di Dati Raccolti</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Il sito raccoglie i seguenti dati personali:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Dati di navigazione:</strong> indirizzo IP, tipo di browser, sistema operativo, pagine visitate</li>
                <li><strong>Dati forniti volontariamente:</strong> nome, email, telefono tramite form di contatto</li>
                <li><strong>Cookie:</strong> come descritto nella nostra Cookie Policy</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">3. Finalità e Base Giuridica del Trattamento</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                I tuoi dati personali sono trattati per le seguenti finalità:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li><strong>Rispondere alle richieste di contatto:</strong> base giuridica - esecuzione di misure precontrattuali (art. 6.1.b GDPR)</li>
                <li><strong>Migliorare il sito web:</strong> base giuridica - legittimo interesse (art. 6.1.f GDPR)</li>
                <li><strong>Analisi statistiche (con consenso):</strong> base giuridica - consenso (art. 6.1.a GDPR)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">4. Modalità del Trattamento</h2>
              <p className="text-gray-700 leading-relaxed">
                I dati personali sono trattati con strumenti informatici e telematici, con logiche strettamente
                correlate alle finalità indicate e con l'adozione delle misure di sicurezza appropriate per
                prevenire perdita, uso illecito o non corretto e accessi non autorizzati.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">5. Conservazione dei Dati</h2>
              <p className="text-gray-700 leading-relaxed">
                I dati personali vengono conservati per il tempo strettamente necessario a conseguire le finalità
                per le quali sono stati raccolti:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
                <li>Dati di contatto: fino a richiesta di cancellazione o 2 anni dall'ultimo contatto</li>
                <li>Dati di navigazione: fino a 26 mesi (Google Analytics)</li>
                <li>Cookie: come specificato nella Cookie Policy</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">6. Comunicazione e Diffusione dei Dati</h2>
              <p className="text-gray-700 leading-relaxed">
                I dati personali non sono oggetto di diffusione. Possono essere comunicati a:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
                <li>Fornitori di servizi tecnici (hosting, email)</li>
                <li>Google Analytics (previo consenso)</li>
                <li>Autorità competenti in caso di obbligo di legge</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">7. Trasferimento Dati Extra-UE</h2>
              <p className="text-gray-700 leading-relaxed">
                I dati potrebbero essere trasferiti a Google LLC (USA) per servizi di analytics.
                Google aderisce al EU-US Data Privacy Framework garantendo un livello adeguato di protezione.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">8. Diritti dell'Interessato</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Ai sensi degli articoli 15-22 del GDPR, hai diritto di:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Accedere ai tuoi dati personali</li>
                <li>Ottenere la rettifica o la cancellazione degli stessi</li>
                <li>Limitare il trattamento</li>
                <li>Opporti al trattamento</li>
                <li>Richiedere la portabilità dei dati</li>
                <li>Revocare il consenso in qualsiasi momento</li>
                <li>Proporre reclamo all'Autorità Garante (www.garanteprivacy.it)</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Per esercitare i tuoi diritti, contattaci via email: <strong>mangimirubini@gmail.com</strong>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">9. Modifiche alla Privacy Policy</h2>
              <p className="text-gray-700 leading-relaxed">
                Questa Privacy Policy può essere modificata nel tempo. Ti invitiamo a consultarla periodicamente.
                Ogni modifica sostanziale sarà comunicata tramite avviso sul sito.
              </p>
            </section>

            <section className="border-t pt-6">
              <p className="text-sm text-gray-500">
                Ultimo aggiornamento: 19 Novembre 2025
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
